import { WorkspaceTeamScene } from '@/features/workspaces/WorkspaceTeamScene';
import { useLocalSearchParams } from 'expo-router';

export default function WorkspaceTeamScreen() {
  const { id } = useLocalSearchParams<{ id?: string }>();
  const organizationID = typeof id === 'string' ? id : '';

  return <WorkspaceTeamScene organizationID={organizationID} />;
}
